export default {
	nav: [
		{ page: '', props: {} }
	]
}



// WEBPACK FOOTER //
// ./src/state.js